import { omit } from 'ramda';

import { fetchRealtyValuation } from './fetchRealtyValuation';
import { getJKid } from '../../selectors/newbuilding';
import { selectPricesFiltersState, selectSalesFiltersState } from '../../selectors/realtyValuation';
import { prepareUpdatedData } from './utils/prepareUpdatedData';
import { EValuationTabs } from '../../containers/RealtyValuation/constants/tabs';
import { TGetNewbuildingValuationBlockWebRequest } from '../../repositories/newbuilding-estimate/v2/get-newbuilding-valuation-block-web';
import { failureAction, requestAction, successAction } from '../../slices/realtyValuation';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';

export const updateRealtyValuationAction = createAsyncThunk<void, EValuationTabs, IThunkApi>(
  'realtyValuation/updateRealtyValuation',
  async (fromTab: EValuationTabs, thunkApi) => {
    const { dispatch, getState, extra } = thunkApi;

    const state = getState();
    const newbuildingId = getJKid(state);
    const pricesFilters = selectPricesFiltersState(state);
    const salesFilters = selectSalesFiltersState(state);
    dispatch(requestAction());

    const parameters = prepareParameters({ newbuildingId, pricesFilters, salesFilters }, fromTab);

    const res = await fetchRealtyValuation({ context: extra, ...parameters });

    if (res instanceof Error) {
      dispatch(failureAction());
    } else {
      const data = prepareUpdatedData(res, fromTab);

      dispatch(successAction(data));
    }
  },
);

/** Подготавливает параметры запроса. В запросе должно присутствовать что-то одно из фильтров, либо ничего */
export function prepareParameters(
  rawParameters: TGetNewbuildingValuationBlockWebRequest,
  fromTab: EValuationTabs,
): TGetNewbuildingValuationBlockWebRequest {
  return omit([fromTab === EValuationTabs.PriceDynamic ? 'salesFilters' : 'pricesFilters'], rawParameters);
}
